import React, { FC, HTMLAttributes } from 'react'

import { Typography } from '@smarty-nx/ds'
import cn from 'classnames'

import classes from './coverage-block.module.scss'
import { coverageBlockContent } from './CoverageBlock.content'
import { Icon } from '../../components/shared'
import TextLink from '../../components/TextLink'
import ThreeLogo from '../../static/images/VodafoneThreeLogo.webp'

interface CoverageBlockProps extends HTMLAttributes<HTMLDivElement> {
  hasFullCoverage?: boolean
}

const CoverageBlock: FC<CoverageBlockProps> = ({
  hasFullCoverage,
  className,
  ...props
}) => (
  <div className={cn(classes.root, className)} {...props}>
    <div className={classes.statementWrapper}>
      <Typography
        component="h3"
        variant="Kollektif/Large"
        className={classes.heading}
        data-testid="coverage-heading"
      >
        {coverageBlockContent.heading}
      </Typography>
      <Icon
        src={ThreeLogo}
        width="auto"
        height="40px"
        margin="0 0 0 10px"
        alt={coverageBlockContent.logoAlt}
        loading="lazy"
        data-testid="vodafone-three-logo"
      />
    </div>

    <Typography
      variant="Kollektif/Small"
      className={classes.smallParagraph}
      data-testid="coverage-text"
    >
      {hasFullCoverage ? (
        <TextLink
          to={coverageBlockContent.coverageLinkTo}
          dataTestId={coverageBlockContent.coverageLinkDataTestId}
        >
          {coverageBlockContent.fullCoverageText}
        </TextLink>
      ) : (
        <>
          <span className={classes.highlight}>
            {coverageBlockContent.coverageStat}
          </span>{' '}
          {coverageBlockContent.coverageSuffix}{' '}
          <TextLink
            to={coverageBlockContent.coverageLinkTo}
            dataTestId={coverageBlockContent.coverageLinkDataTestId}
          >
            {coverageBlockContent.checkCoverageText}
          </TextLink>
        </>
      )}
    </Typography>
  </div>
)

export default CoverageBlock
